// This file was automatically generated from ptdata.ptAllergies.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.ptAllergies');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptAllergies.documentedAsNonePatientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('NKDA (No known drug allergies)');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptAllergies.documentedAsNoneSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('NKDA');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptAllergies.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.allergy.name), (opt_data.reaction) ? ' = ' + soy.$$escapeHtml(opt_data.reaction) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptAllergies.patientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    el8.template.ptdata.ptAllergies.documentedAsNoneSummary(null, output);
  } else {
    if (! opt_data.actives.length) {
      output.append('HAVE NOT ASKED');
    } else {
      var aList22004 = opt_data.actives;
      var aListLen22004 = aList22004.length;
      for (var aIndex22004 = 0; aIndex22004 < aListLen22004; aIndex22004++) {
        var aData22004 = aList22004[aIndex22004];
        el8.template.ptdata.ptAllergies.summary(aData22004, output);
        output.append((! (aIndex22004 == aListLen22004 - 1)) ? ', ' : '');
      }
    }
  }
  if (!opt_sb) return output.toString();
};
